import type {Mapper} from 'framework';
import type {CatalogCandidate} from '../../domain/catalog-candidate';
import type {CatalogCandidatesDto} from '../dto/product.dto';
import type {ProductDtoToProductMapper} from './product-dto-to-product.mapper';

type CandidatesSuccess = Extract<CatalogCandidatesDto, {data: readonly unknown[]}>;
type CandidateDto = CandidatesSuccess['data'][number];

export class CatalogCandidateDtoToCandidateMapper implements Mapper<
  CandidateDto,
  CatalogCandidate
> {
  constructor(private readonly productMapper: ProductDtoToProductMapper) {}

  transform(dto: CandidateDto): CatalogCandidate {
    if (dto.source === 'user_product') {
      return {source: 'user_product', product: this.productMapper.transform(dto.product)};
    }
    if (dto.source === 'open_food_facts') {
      return {
        source: 'open_food_facts',
        barcode: dto.barcode,
        productName: dto.productName,
        brand: dto.brand,
        kcalPer100g: dto.kcalPer100g,
        proteinPer100g: dto.proteinPer100g,
        carbsPer100g: dto.carbsPer100g,
        fatPer100g: dto.fatPer100g,
      };
    }
    return {
      source: 'usda',
      fdcId: dto.fdcId,
      productName: dto.productName,
      brand: dto.brand,
      kcalPer100g: dto.kcalPer100g,
      proteinPer100g: dto.proteinPer100g,
      carbsPer100g: dto.carbsPer100g,
      fatPer100g: dto.fatPer100g,
    };
  }
}
